
function LabelledSelect ( { id, label, value, onChange, options } )
{
    return  <div className="py-2">
                <label htmlFor={id}>{label}</label>
                <select id={id} value={value} onChange={ ( e ) => onChange ( e.target.value ) }>
                    { options.map ( option => <option key={option.value} value={option.value}>{option.label}</option> ) }
                </select>
            </div>
}

export default LabelledSelect;